import Cookies from 'js-cookie';

const VERSION_KEY = 'app_version';
const RESET_GUARD_KEY = 'app_version_reset_guard';

function clearCookiesBestEffort() {
	const all = Cookies.get();
	const names = Object.keys(all);

	const hostname = window.location.hostname;
	const parts = hostname.split('.');
	const baseDomain =
		parts.length >= 2 ? `.${parts.slice(-2).join('.')}` : hostname;

	names.forEach((name) => {
		Cookies.remove(name);
		Cookies.remove(name, { path: '/' });
		Cookies.remove(name, { path: '/', domain: hostname });
		Cookies.remove(name, { path: '/', domain: baseDomain });
	});
}

async function clearServiceWorkerAndCaches() {
	if ('caches' in window) {
		const keys = await caches.keys();
		await Promise.all(keys.map((k) => caches.delete(k)));
	}

	if ('serviceWorker' in navigator) {
		const regs = await navigator.serviceWorker.getRegistrations();
		await Promise.all(regs.map((r) => r.unregister()));
	}
}

function purgeReduxPersist() {
	try {
		localStorage.removeItem('persist:root');
	} catch (e) {}
}

export async function enforceAppVersion(currentVersion) {
	//  If we already wiped for this version in THIS tab session, don't do it again.
	try {
		const guard = sessionStorage.getItem(RESET_GUARD_KEY);
		if (guard === currentVersion) {
			// Ensure version is stored and continue boot normally
			try {
				localStorage.setItem(VERSION_KEY, currentVersion);
				console.info('Version is stored');
			} catch (e) {
				console.error('Failed to set version', e);
			}
			return;
		}
	} catch (e) {
		console.error('Failed to get guard', e);
	}

	let stored = null;
	try {
		stored = localStorage.getItem(VERSION_KEY);
	} catch (e) {}

	if (!stored || stored !== currentVersion) {
		//  Mark guard BEFORE clearing localStorage
		try {
			sessionStorage.setItem(RESET_GUARD_KEY, currentVersion);
			console.info('Guard is set');
		} catch (e) {
			console.error('Failed to set guard', e);
		}

		// Purge redux-persist first
		purgeReduxPersist();

		// Clear storages
		try {
			sessionStorage.clear();
			// Put guard back after session clear (since we just cleared it)
			sessionStorage.setItem(RESET_GUARD_KEY, currentVersion);
			console.info('Session storage cleared');
		} catch (e) {
			console.error('Failed to clear session storage', e);
		}

		try {
			localStorage.clear();
			console.info('Local storage cleared');
		} catch (e) {
			console.error('Failed to clear local storage', e);
		}

		// Cookies (JS accessible only)
		try {
			clearCookiesBestEffort();
			console.info('Cookies cleared');
		} catch (e) {
			console.error('Failed to clear cookies', e);
		}

		// SW + caches
		try {
			await clearServiceWorkerAndCaches();
			console.info('Service worker and caches cleared');
		} catch (e) {
			console.error('Failed to clear service worker and caches', e);
		}

		// Store new version
		try {
			localStorage.setItem(VERSION_KEY, currentVersion);
			console.info('Version is stored');
		} catch (e) {
			console.error('Failed to set version', e);
		}

		window.location.reload();
	}
}
